<template>
  <div class="">
    <el-form :inline="true" label-width="90px">
      <el-row :gutter="26">
        <el-col
          :span="22"
          class="key-input"
          style="border-right: 1px #e5e6eb solid"
        >
          <el-row :span="22">
            <el-col :span="12">
              <el-form-item label="搜索">
                <el-input
                  clearable
                  v-model="searchInfo.keyword"
                  placeholder="用户昵称、手机号、用户ID、设备SN搜索"
                  size="mini"
                  suffix-icon="el-icon-search"
                  width="100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" style="width: 100%">
                <el-select
                  clearable
                  v-model="searchInfo.achieve"
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="报名时间">
                <el-date-picker
                  clearable
                  v-model="dateNow"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                  size="mini"
                  @change="handleDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="2" class="right-button">
          <el-button icon="el-icon-search" @click="search">查询</el-button>
          <el-button
            class="reset-btn"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <div style="border-bottom: 1px #e5e6eb solid; margin: 20px 0"></div>
    <el-row>
      <el-table
        v-loading="loading"
        empty-text="暂无数据"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column align="center" label="用户ID" width="120" prop="uid">
          <template slot-scope="scope">
            <a
              href="javascript:;"
              :style="{
                color: '#165DFF',
                cursor: 'pointer',
              }"
              @click="toUserDetail(scope)"
            >
              {{ scope.row.uid || "--" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column align="center" label="用户" prop="un">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" width="auto">
              <div
                slot="reference"
                @click="toUserDetail(scope)"
                class="submitted"
              >
                {{ scope.row.un || "--" }}
              </div>
              <div
                style="
                  display: flex;
                  text-overflow: ellipsis;
                  white-space: pre-line;
                  cursor: pointer;
                  color: #165dff;
                  justify-content: center;
                "
              >
                <span @click="toUserDetail(scope)">
                  {{ scope.row.un || "--" }}
                </span>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="手机号"
          prop="phone"
        ></el-table-column>
        <el-table-column
          align="center"
          label="设备ID"
          prop="deviceId"
          width="180"
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              :style="{
                color: '#165DFF',
                cursor: 'pointer',
              }"
              @click="goDevDetail(scope.row.gdid)"
            >
              {{ scope.row.deviceId || "--" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="有效天数"
          prop="customerName"
          width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.effectiveDays || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="报名时间"
          prop="regTime"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.regTime || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" width="100">
          <template slot-scope="scope">
            <div class="status-content">
              <div
                class="status-color"
                :style="getStatusColor(scope.row.achieve)"
              ></div>
              <span> {{ tableStatusText[scope.row.achieve] || "挑战中" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="审核意见" prop="comment">
          <template slot-scope="scope">
            <el-popover
              trigger="hover"
              placement="top"
              v-if="scope.row.comment"
            >
              <div
                slot="reference"
                class="submitted"
                style="cursor: default; color: #4e5969"
              >
                {{ scope.row.comment || "--" }}
              </div>
              <div
                style="
                  display: flex;
                  text-overflow: ellipsis;
                  white-space: pre-line;
                  justify-content: center;
                "
              >
                <span>
                  {{ scope.row.comment || "--" }}
                </span>
              </div>
            </el-popover>
            <span v-else style="display: flex; justify-content: center">
              --
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="opr" width="260">
          <template slot-scope="scope">
            <a
              :href="`${promotion.url}?userid=${scope.row.uid}`"
              style="color: #165dff; font-weight: 400"
              target="_blank"
              rel="noopener noreferrer"
            >
              活动详情
            </a>
            <el-button
              type="text"
              style="font-weight: 400; margin-left: 10px"
              @click="handleDownload(scope.row.id)"
            >
              导出数据
            </el-button>
            <el-button
              type="text"
              style="font-weight: 400"
              @click="showOptionDialog(scope.row)"
            >
              审核意见
            </el-button>
            <el-button
              type="text"
              style="font-weight: 400"
              @click="del(scope.row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page" style="margin-top: 20px">
        <el-pagination
          @current-change="changepagefn"
          :page-size="size"
          :current-page="page"
          @size-change="handleSizeChange"
          :page-sizes="[5, 10, 20, 50, 100]"
          layout="->,sizes,total,prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="审核意见"
      :visible.sync="auditOpinionShow"
      width="40%"
      center
    >
      <div>
        <span class="audit-opinion-desc"
          >审核用户数据有疑议或该用户存在不当行为的可提交审核意见，线下工作人员查询设备兑奖情况时可参考审核意见。</span
        >
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            label-position="top"
          >
            <el-form-item label="审核意见" prop="desc" class="audit-opinion">
              <el-input
                type="textarea"
                v-model="ruleForm.desc"
                maxlength="300"
                :clearable="true"
                :show-word-limit="true"
                :autosize="{ minRows: 4 }"
                placeholder="请输入审核意见"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="dialog-btn" @click="auditOpinionShow = false">
          <span>取 消</span>
        </div>
        <div class="dialog-btn confirm-btn" @click="saveOpinion">
          <span>确 定</span>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// const _baseUrl = process.env.VUE_APP_activeDownloadUrl;
import { env } from "@/utils/util.js";
export default {
  props: {
    promotion: {},
  },
  data() {
    return {
      tableData: [],
      searchInfo: {
        achieve: "",
        keyword: "",
        regTime: "",
      },
      ruleForm: { desc: "" },
      rules: {
        desc: [{ required: true, message: "请输入审核意见", trigger: "blur" }],
      },
      auditOpinionShow: false,
      tableStatusText: {
        1: "挑战成功",
        "-1": "挑战失败",
      },
      size: 10,
      total: 0,
      page: 1,
      dateNow: "",
      loading: false,
      statusList: [
        {
          key: 4,
          value: "全部",
        },
        {
          key: 1,
          value: "成功",
        },
        {
          key: -1,
          value: "失败",
        },
        {
          key: 3,
          value: "挑战中",
        },
      ],
      curId: "",
      downloadBaseURL: "",
    };
  },
  created() {
    // this.getDataList();
  },
  watch: {
    promotion(newVal, oldVal) {
      if (newVal.id) {
        this.getDataList();
      }
    },
  },
  mounted() {
    const url = env();
    this.downloadBaseURL = url.downloadUrl;
  },
  methods: {
    showOptionDialog(val) {
      this.auditOpinionShow = true;
      this.curId = val.id;
      this.ruleForm.desc = val.comment;
    },
    saveOpinion() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submitAuditOpinion();
        } else {
          return false;
        }
      });
    },
    submitAuditOpinion() {
      this.auditOpinionShow = false;
      this.$post("/promotion/user/comments", {
        comment: this.ruleForm.desc,
        id: this.curId,
      }).then((res) => {
        // console.log("submitAuditOpinion", res);
        if (res.data?.code === 1000) {
          this.getDataList();
        } else {
          this.$message.error(res.data?.msg);
        }
        this.ruleForm.desc = "";
        this.curId = "";
      });
    },
    handleDownload(promotionUserId) {
      // 创建隐藏的a标签实现下载‌:ml-citation{ref="5,7" data="citationList"}
      console.log(
        "this.downloadBaseURL",
        `${this.downloadBaseURL}/promotion/downloadUserData?promotionUserId=${promotionUserId}`
      );

      const link = document.createElement("a");
      link.href = `${this.downloadBaseURL}/promotion/downloadUserData?promotionUserId=${promotionUserId}`; // 后端文件接口地址
      link.style.display = "none";

      // 设置下载文件名（可选，需与后端Content-Disposition一致）‌:ml-citation{ref="4,8" data="citationList"}
      link.download = "document.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 释放浏览器缓存资源‌:ml-citation{ref="3,6" data="citationList"}
      setTimeout(() => URL.revokeObjectURL(link.href), 100);
    },
    // 查看用户详情
    toUserDetail(scope) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: scope.row.uid,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    // 查看设备详情
    goDevDetail(id) {
      if (this.$jumpPerm("device_detail")) {
        this.mskflag = false;
        this.$router.push({
          path: "/devDetail",
          query: {
            id,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    getDataList() {
      const achieve = this.searchInfo.achieve;
      let regTime = "";
      if (this.dateNow)
        regTime =
          `${this.dateNow[0]} 00:00:00` + "~" + `${this.dateNow[1]} 23:59:59`;

      this.$get("/promotion/user", {
        page: this.page,
        size: this.size,
        promotionId: this.promotion?.id,
        ...this.searchInfo,
        achieve: achieve === 4 ? "" : achieve,
        regTime,
      }).then((res) => {
        // console.log("res", res);
        if (res.data?.code === 1000) {
          this.tableData = res.data?.data?.list;
          this.total = res.data?.data?.count;
        }
      });
    },
    getStatusColor(value) {
      switch (value) {
        case 1:
          return { backgroundColor: "#00B42A" };
        case -1:
          return { backgroundColor: "#F53F3F" };
        default:
          return { backgroundColor: "#165DFF" };
      }
    },
    search() {
      this.getDataList();
    },
    handleDateChange(dates) {
      // if (dates && dates.length) {
      //   const regTime = `${dates[0]} 00:00:00` + "~" + `${dates[1]} 23:59:59`;
      //   this.searchInfo.regTime = regTime;
      // }
    },
    reset() {
      this.dateNow = "";
      this.searchInfo = {
        achieve: "",
        keyword: "",
        regTime: "",
      };
      this.getDataList();
    },
    changepagefn(index) {
      this.page = index;
      this.getDataList(this.searchInfo);
    },
    handleSizeChange(val) {
      this.size = val;
      this.getDataList(this.searchInfo);
    },
    del(id) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // this.$message({
        //   type: "success",
        //   message: "删除成功!",
        // });
        this.$post(`/promotion/user/del?id=${id}`, {}).then((res) => {
          if (res.data?.code === 1000) {
            this.getDataList();
          } else {
            this.$message.error(res.data?.msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.submitted {
  color: #165dff;
  cursor: pointer;
  // width: 90px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 超出显示省略号 */
}
.el-popover {
  width: auto !important;
}
.right-button {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  .el-button {
    width: 82px;
    height: 28px;
    background-color: #165dff;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-top: 5px;
  }
  .reset-btn {
    color: #4e5969;
    background-color: #f2f3f5;
    margin-left: 0 !important;
    margin-top: 13px;
  }
}
::v-deep .key-input .el-form-item__content {
  width: 100%;
  display: flex;
  align-items: center;
}
::v-deep .key-input1 {
  width: 100%;
}

::v-deep .key-input .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .el-form-item {
  display: flex !important;
}
.status-content {
  display: flex;
  width: 100%;
  align-items: center;
  // justify-content: space-between;
}
.status-color {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  // background-color: #ff7d00;
}
.audit-opinion-desc {
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}
.audit-opinion {
  display: block !important;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0px;
}
::v-deep .el-dialog__body {
  padding: 34px 20px 0px;
}
::v-deep .el-dialog__footer {
  text-align: right;
}
.dialog-footer {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.dialog-btn {
  display: flex;
  width: 60px;
  height: 32px;
  background: #f2f3f5;
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  cursor: pointer;
}
.confirm-btn {
  background-color: #165dff;
  color: #ffffff;
  margin-left: 8px;
}
</style>
